import React, { useEffect } from "react";
import './PrivacyPolicy.scss';
import '../AppComponents/Subscription.scss';
import back from "../assets/icons/back_menu_arrow.png"
import Footer2 from "./Footer2";
import logo from "../assets/icons/logo.png"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const PrivacyPolicy = ({ setOpenPrivacy,openPrivacy,selectedLang,homeLogo }) => {
    // const lang =selectedLang?selectedLang: localStorage.getItem("appLang")?localStorage.getItem("appLang"):'ar';
    const lang = "en"
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const history = useHistory()

    const privacyArray = [
      {
        id: "1",
        heading: {
          en: "Information We Collect",
          ar: "المعلومات التي نجمعها",
        },
        text: [
          {
            en: "When you use our service, we may collect the following types of information:",
            ar: "عندما تستخدم خدمتنا، قد نقوم بجمع الأنواع التالية من المعلومات:",
          },
          {
            en: "Personal Information: Subscription Data: When you subscribe to our service, we collect your mobile phone number and any other necessary billing details. These details help us process your subscription and maintain accurate records.",
            ar: "المعلومات الشخصية: بيانات الاشتراك: عندما تشترك في خدمتنا، نقوم بجمع رقم هاتفك المحمول وأي تفاصيل فواتير ضرورية أخرى. تساعدنا هذه التفاصيل في معالجة اشتراكك والحفاظ على سجلات دقيقة.",
          },
          {
            en: "Age Verification: To comply with age restrictions, we may collect information to ensure that you are over 18 years of age or have permission from a parent or guardian if you are under 18.",
            ar: "التحقق من العمر: للامتثال لقيود العمر، قد نجمع معلومات للتأكد من أن عمرك يزيد عن 18 عامًا أو لديك إذن من أحد الوالدين أو الوصي إذا كان عمرك أقل من 18 عامًا.",
          },
        ],
      },
      {
        id: "2",
        heading: {
          en: "How We Use Your Information",
          ar: "طريقة استخدامنا لمعلوماتك",
        },
        text: [
          {
            en: "Service Provision and Maintenance: To process your subscription, including automatic renewal unless you choose to unsubscribe. To send you and renewal alerts via SMS.",
            ar: "تقديم الخدمة والصيانة: لمعالجة اشتراكك، بما في ذلك التجديد التلقائي ما لم تقم باختيار إلغاء الاشتراك. لإرسال تنبيهات لك بخصوص الاشتراك والتجديدات عبر الرسائل النصية القصيرة.",
          },
          {
            en: "Communication: To send you important service-related updates, such as subscription, renewals. To respond to any feedback or inquiries you submit via contact@telecubesmobile.com.",
            ar: "التواصل: لإرسال تحديثات مهمة متعلقة بالخدمة، مثل الاشتراك والتجديدات. للرد على أي ملاحظات أو استفسارات تقدمها عبر البريد الإلكتروني: contact@telecubesmobile.com.",
          },
          {
            en: "Improvement of Services: To analyze how users interact with our service so that we can improve the platform, including the user interface, content offerings, and overall performance.",
            ar: "تحليل كيفية تفاعل المستخدمين مع خدمتنا حتى نتمكن من تحسين المنصة، بما في ذلك واجهة المستخدم، وعروض المحتوى، والأداء العام.",
          },
        ],
      },
      {
        id: "3",
        heading: {
          en: "Cookies and Tracking Technologies",
          ar: "ملفات تعريف الارتباط وتقنيات التتبع",
        },
        text: [
          {
            en: "We may use cookies and similar tracking technologies to enhance your experience on our portal. Cookies are small data files stored on your device that allow us to: Remember your preferences, such as language settings (the portal is in English). Track usage patterns and improve service performance.",
            ar: "قد نستخدم ملفات تعريف الارتباط وتقنيات التتبع المماثلة لتحسين تجربتك على بوابتنا. ملفات تعريف الارتباط هي ملفات بيانات صغيرة تُخزن على جهازك وتمكننا من: تذكر تفضيلاتك، مثل إعدادات اللغة (البوابة باللغة الإنجليزية). تتبع أنماط الاستخدام وتحسين أداء الخدمة.",
          },
        ],
      },
      {
        id: "4",
        heading: {
          en: "Data Sharing and Disclosure",
          ar: "مشاركة البيانات والإفصاح عنها",
        },
        text: [
          {
            en:"We do not sell or rent your personal information to third parties. However, we may share your information in the following scenarios:",
            ar:"نحن لا نبيع أو نؤجر معلوماتك الشخصية لأطراف ثالثة. ومع ذلك، قد نشارك معلوماتك في الحالات التالية"
          },
          {
            en: "Legal Compliance: We may disclose your information if required to do so by law or in response to valid legal requests from government authorities.",
            ar: "الامتثال القانوني: قد نكشف عن معلوماتك إذا كان ذلك مطلوبًا بموجب القانون أو استجابة لطلبات قانونية صالحة من السلطات الحكومية.",
          },
          {
            en:"Data Security We implement appropriate technical and organizational measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction. However, no method of data transmission or storage is completely secure, and we cannot guarantee the absolute security of your information.",
            ar:"أمن البيانات: نقوم بتنفيذ تدابير فنية وتنظيمية مناسبة لحماية معلوماتك الشخصية من الوصول غير المصرح به أو الكشف عنها أو تعديلها أو تدميرها. ومع ذلك، لا توجد طريقة آمنة تمامًا لنقل البيانات أو تخزينها، ولا يمكننا ضمان الأمان المطلق لمعلوماتك."
          }
        ],
      },
      {
        id: "5",
        heading: {
          en: "Retention of Your Information",
          ar: "الاحتفاظ بمعلوماتك",
        },
        text: [
          {
            en: "We will retain your personal information for as long as necessary to fulfill the purposes outlined in this policy. This may include retaining your data to comply with legal obligations, resolve disputes, and enforce our agreements.",
            ar: "سنحتفظ بمعلوماتك الشخصية طالما كان ذلك ضروريًا لتحقيق الأغراض الموضحة في هذه السياسة. قد يشمل ذلك الاحتفاظ ببياناتك للامتثال للالتزامات القانونية، وحل النزاعات، وتنفيذ اتفاقياتنا.",
          },
        ],
      },
      {
        id: "6",
        heading: {
          en: "Children’s Privacy",
          ar: "خصوصية الأطفال",
        },
        text: [
          {
            en: "Our service is intended for users who are at least 18 years old or who have obtained parental consent. We do not knowingly collect personal information from children under 18. If we become aware that we have inadvertently collected personal data from a child without consent, we will take steps to delete that information.",
            ar: "خدمتنا موجهة للمستخدمين الذين يبلغون من العمر 18 عامًا على الأقل أو الذين حصلوا على موافقة من الوالدين. نحن لا نقوم بجمع معلومات شخصية عن الأطفال تحت سن 18 عامًا بشكل متعمد. إذا اكتشفنا أننا قد جمعنا بيانات شخصية عن طفل دون موافقة، سنتخذ إجراءات لحذف تلك المعلومات.",
          },
        ],
      },
      {
        id: "7",
        heading: {
          en: "Data Usage and Charges",
          ar: "استخدام البيانات والرسوم",
        },
        text: [
          {
            en: "Please note that standard data charges may apply when browsing or downloading content from our portal if you are not using a data bundle. It is your responsibility to manage your data usage according to your mobile plan.",
            ar: "يُرجى ملاحظة أنه قد تُطبق رسوم بيانات قياسية عند التصفح أو تنزيل المحتوى من بوابتنا إذا كنت لا تستخدم باقة بيانات. تقع على عاتقك مسؤولية إدارة استخدامك للبيانات وفقًا لخطة الهاتف المحمول الخاصة بك.",
          },
        ],
      },
      {
        id: "8",
        heading: {
          en: "International Data Transfers",
          ar: "التحويل الدولي للبيانات",
        },
        text: [
          {
            en: "We operate globally, and your information may be transferred to and processed in countries outside your own. We ensure that any data transfers comply with applicable privacy laws and that your data is protected by adequate safeguards.",
            ar: "نحن نعمل على مستوى عالمي، وقد يتم نقل معلوماتك ومعالجتها في دول خارج بلدك. نضمن أن أي نقل للبيانات يتوافق مع قوانين الخصوصية السارية وأن بياناتك محمية بتدابير وقائية كافية.",
          },
        ],
      },
      {
        id: "9",
        heading: {
          en: "Changes to This Privacy Policy",
          ar: "التغييرات في سياسة الخصوصية هذه",
        },
        text: [
          {
            en: "We may update this Privacy Policy from time to time to reflect changes in our practices or relevant legal requirements. We will notify you of any significant changes by posting a notice on our portal or sending an SMS alert. Your continued use of the service after such changes constitutes acceptance of the revised policy.",
            ar: "قد نقوم بتحديث سياسة الخصوصية هذه من حين لآخر لتعكس التغييرات في ممارساتنا أو المتطلبات القانونية ذات الصلة. سنقوم بإعلامك بأي تغييرات هامة عن طريق نشر إشعار على بوابتنا أو إرسال تنبيه عبر الرسائل النصية القصيرة. إن استمرارك في استخدام الخدمة بعد هذه التغييرات يعتبر قبولًا بالسياسة المعدلة.",
          },
        ],
      },
      {
        id: "10",
        heading: {
          en: "Contact Us",
          ar: "تواصل معنا",
        },
        text: [
          {
            en: "If you have any questions, concerns, or feedback regarding this Privacy Policy or our data handling practices, please contact us at contact@telecubesmobile.com",
            ar: "إذا كانت لديك أي أسئلة أو مخاوف أو ملاحظات بخصوص سياسة الخصوصية هذه أو ممارساتنا في التعامل مع البيانات، يُرجى الاتصال بنا على البريد الإلكتروني: contact@telecubesmobile.com.",
          },
          {
            en:"By using our service, you acknowledge that you have read and understood this Privacy Policy and agree to the collection, use, and disclosure of your personal information as described herein.",
            ar:"باستخدامك لخدمتنا، فإنك تقر بأنك قرأت وفهمت سياسة الخصوصية هذه وتوافق على جمع واستخدام وكشف معلوماتك الشخصية كما هو موضح هنا."
          }
        ],
      },
    ];
    

   const handleBack=()=>
    {
        if(openPrivacy && openPrivacy!==undefined)
            {
                setOpenPrivacy(false)
            }
            else{

                history.push("/subs")
            }
        // window.location.replace("/")
    }
    return (
        <div className="privacy-policy-container">
            <div className="images">
            <img 
                className="lang"
                src={back}
                alt="back"
                onClick={handleBack}></img>
                <img 
                className="logosub"
                alt="logo"
                src={homeLogo ? homeLogo : logo}></img>
                
            </div> 
            <div className={`privacyText ${lang === "ar" ? "rtl" : ""}`}>
            <p>{lang === "en" ? "At Telecubes Mobile Services, Cubegames, we value your privacy and are committed to protecting your personal information. This Privacy Policy outlines how we collect, use, and share your information when you subscribe to our service. By subscribing to our service, you consent to the practices described in this policy. Please read this policy carefully to understand how we handle your information."
: "في خدمات Telecubes Mobile، Cubegames، نحن نقدر خصوصيتك وملتزمون بحماية معلوماتك الشخصية. توضح سياسة الخصوصية هذه كيف نجمع بياناتك ونستخدمها ونشاركها ونحميها عند اشتراكك في خدماتنا. يعدّ الاشتراك في خدماتنا بمثابة الموافقة على الممارسات الموضحة في سياسة الخصوصية. يُرجى قراءة هذه السياسة بعناية لفهم كيفية تعاملنا مع معلوماتك." }</p>
            {privacyArray && privacyArray.map((item)=>{
                return(
                    <>
                    <h1>{item.heading[lang]}</h1>
                    {item.text &&
          item.text.map((textItem, index) => (
            <p key={index}>{textItem[lang] ? textItem[lang] : ""}</p>
          ))}
                    </>
                )
            })}
           
            <Footer2/>
        </div>
        </div>
        
    );
}

export default PrivacyPolicy